import { render } from "./cretetimingdetail.vue?vue&type=template&id=7f70d4f9&scoped=true"
import script from "./cretetimingdetail.vue?vue&type=script&lang=ts"
export * from "./cretetimingdetail.vue?vue&type=script&lang=ts"

import "./cretetimingdetail.vue?vue&type=style&index=0&id=7f70d4f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f70d4f9"

export default script